import { render, staticRenderFns } from "./modal-card.vue?vue&type=template&id=7847d740&"
import script from "./modal-card.vue?vue&type=script&lang=ts&"
export * from "./modal-card.vue?vue&type=script&lang=ts&"
import style0 from "./modal-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7847d740')) {
      api.createRecord('7847d740', component.options)
    } else {
      api.reload('7847d740', component.options)
    }
    module.hot.accept("./modal-card.vue?vue&type=template&id=7847d740&", function () {
      api.rerender('7847d740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/modal-card.vue"
export default component.exports